module.exports = __webpack_public_path__ + "static/icons/gif-aniversario.9abf6ea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gif-aniversario.gif
// module id = BK6i
// module chunks = 1